import { Roles } from '@omnea-digital/toolbox'
import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RenewalsHttpClient } from '@omnea-app/renewals/renewalsHttpClient'
import { renewalKeys } from './query-key-factory'

const selectActionNeededCount = (stats: { actionNeededCount: number }) => stats.actionNeededCount

export const useRenewalsActionNeededCount = () => {
  const { user, getToken } = useAuthenticatedUser()

  return useQuery({
    enabled: user.role === Roles.ADMIN || user.role === Roles.USER,
    queryKey: renewalKeys.stats(user.id),
    staleTime: Infinity,
    gcTime: Infinity,
    queryFn: async () => {
      const authorization = await getToken()
      const renewalsApiClient = new RenewalsHttpClient({ authorization })

      const { data, error } = await renewalsApiClient.GET('/get-stats')

      if (error) throwIfApiError(error)

      return data.renewalStats
    },
    select: selectActionNeededCount,
  })
}
